import { MutationTree } from 'vuex'
import { PronosticoLocalMapasState, StoreError } from './types'

export const mutations: MutationTree<PronosticoLocalMapasState> = {
  PRONOSTICO_LOCAL_FETCHED (state, payload: PronosticoLocalMapasState) {
    state.error = { state: false }
    state.inicio = payload.inicio
    state.imagenes = payload.imagenes
    state.pasos = payload.pasos
    state.ruta = payload.ruta
    state.fecha_inicio_nieve = payload.fecha_inicio_nieve
    state.centro = payload.centro
    state.latlong = payload.latlong
    state.delta = payload.delta
    state.etiquetas = payload.etiquetas
  },
  PRONOSTICO_LOCAL_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
